import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-report-search-invoice',
  templateUrl: './report-search-invoice.component.html',
  styleUrls: ['./report-search-invoice.component.css']
})
export class ReportSearchInvoiceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
